import { render } from "./ReportHedis.vue?vue&type=template&id=5bf5b802&scoped=true"
import script from "./ReportHedis.vue?vue&type=script&lang=js"
export * from "./ReportHedis.vue?vue&type=script&lang=js"

import "./ReportHedis.vue?vue&type=style&index=0&id=5bf5b802&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf5b802"]])

export default __exports__